import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";

import { UnitList } from "./UnitList";

const mapStateToProps = (state: FullFormState) => ({
    currentUnit: state.highlightUnit,
});

export const UnitListContainer = connect(mapStateToProps)(withTestPageObjectRegistration(UnitList, () => ["UnitList"]));
